<template>
  <div>
    <v-snackbar v-model="showCustomer" top left color="success" timeout="-1">
      {{ $t("loginAs") }}: {{ customer }}

      <template #action>
        <v-btn color="white" text @click="showCustomer = false">
          {{ $t("COMMON.OK") }}
        </v-btn>
      </template> </v-snackbar
    ><v-snackbar v-model="showError" top left color="danger" timeout="-1">
      {{ $t("COMMON.ERROR") }}: {{ error }}

      <template #action>
        <v-btn color="red" text @click="showError = false">
          {{ $t("COMMON.OK") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { configureInstance, setLanguage } from "@/services/api";

export default {
  name: "LoginAsCustomer",
  data() {
    return {
      customer: "",
      showCustomer: false,
      error: "",
      showError: false,
    };
  },
  computed: { ...mapState(["lang"]) },
  created() {
    const params = new URLSearchParams(this.$route.query);

    const loginAs = params.get("loginAs");
    const email = params.get("email");
    const password = params.get("password");

    if (loginAs && email && password) {
      this.login(loginAs, email, password);
    }
  },
  methods: {
    async login(loginAs, email, password) {
      try {
        const response = await this.performLogin(loginAs, email, password);
        this.handleValidResponse(response);
      } catch (err) {
        this.handleError(err);
      }
    },
    async handleValidResponse(response) {
      this.$store.commit("logIn", response.data);
      this.$store.commit("setIsPreview", true);
      configureInstance(response.data.token);
      setLanguage(response.data.language || this.lang || "en");

      this.customer = response.data.displayname;
      this.showCustomer = true;
    },
    performLogin(loginAs, email, password) {
      const data = {
        action: "login",
        loginAs,
        email,
        password,
      };
      return this.$http.post("/login", data);
    },
    handleError(err) {
      const error = (err.response && err.response.data) || err;
      this.alert = error.message || error.errmsg || error;
      this.error = error;
      this.showError = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
